/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Modal,
  Button,
  Table,
} from 'react-bootstrap';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';
import { callAPI } from 'lorautils/api';
import IntlMsg from 'lorautils/intl/IntlMsg';
import dashboardActions from 'loraactions/dashboard';
import Checkbox from 'loracoms/Checkbox';
import InlineSelect from 'loracoms/InlineSelect';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired,
  appId: PropTypes.string.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  // dps: PropTypes.string,
};

const defaultProps = {
  dps: '',
};

class AddDps extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
      checked: [],
      dataPoints: [],
      lists: [],
      modalType: 'single',
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
    this.isChecked = this.isChecked.bind(this);
    this.allChecked = this.allChecked.bind(this);
  }

  componentWillMount() {
    this.loadDps();
  }

  componentWillReceiveProps(nextProps) {
    const { showModal } = nextProps;
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
    }
    // this.setState({ checked: _.split(dps, ',') });
  }

  loadDps() {
    const { appId } = this.props;
    callAPI({
      endpoint: '/lora/dps',
      query: {
        appid: appId,
      },
    }).then((data) => {
      this.setState({
        dataPoints: data.list,
        lists: data.list.map(l => l.id),
      });
    }).catch(() => {});
  }

  isChecked(d) {
    return _.includes(this.state.checked, d);
  }

  toggleCheck(d) {
    const checked = this.state.checked;
    if (this.isChecked(d)) {
      this.setState({
        checked: _.filter(checked, a => a !== d),
      });
    } else {
      checked.push(d);
      this.setState({ checked });
    }
  }

  allChecked() {
    const { lists, checked } = this.state;
    return (
      lists.length > 0 &&
      lists.length === checked.length
    );
  }

  handleToggleCheckAll() {
    this.setState({
      checked: this.allChecked() ? [] : this.state.lists,
    });
  }

  handleChangeModalType(modalType) {
    this.setState({ modalType });
  }

  handleOnConfirm() {
    const { onConfirm } = this.props;
    const { modalType, checked } = this.state;
    this.handleOnCancel();
    onConfirm(_.join(checked, ','), modalType);
  }

  handleOnCancel() {
    this.props.onHide();
    this.setState({
      checked: [],
      modalType: 'single',
    });
  }

  render() {
    const {
      showModal,
      dataPoints = [],
      modalType,
    } = this.state;
    const rows = dataPoints.filter(it => it.id !== 'lat' && it.id !== 'lng')
      .map(item => (
        <tr key={item.id}>
          <td>
            <Checkbox
              id={item.id}
              checked={this.isChecked(item.id)}
              onChange={() => this.toggleCheck(item.id)}
            />
          </td>
          <td>{item.id}</td>
          <td>{item.desc}</td>
        </tr>
    ));

    const kOption = [
      { label: this.intlMsg.msg('singlechart'), value: 'single' },
      { label: this.intlMsg.msg('mergechart'), value: 'merge' },
    ];

    return (
      <Modal
        show={showModal}
        bsSize="large"
        bsClass="aisz-modal-light"
      >
        <Modal.Header>{this.intlMsg.msg('adddashboard.add.datapoint')}</Modal.Header>
        <Modal.Body className={styles.content}>
          <InlineSelect
            bsStyle="aisz-primary"
            options={kOption}
            values={[modalType]}
            onChange={selected => this.handleChangeModalType(selected[0])}
          />
          <Table
            className="aisz-table-light"
            style={{ marginTop: '20px' }}
            bordered
            responsive
          >
            <thead>
              <tr>
                <th>
                  <Checkbox
                    id="all"
                    checked={this.allChecked()}
                    onChange={e => this.handleToggleCheckAll(e)}
                  />
                </th>
                <th>{this.intlMsg.msg('addmodal.name')}</th>
                <th>{this.intlMsg.msg('dpsmodal.desc')}</th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="aisz-success"
            onClick={() => this.handleOnConfirm()}
          >
            {this.intlMsg.msg('confirm')}
          </Button>
          <Button
            bsStyle="aisz-default"
            className={styles.white}
            onClick={() => this.handleOnCancel()}
          >
            {this.intlMsg.msg('cancel')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

AddDps.propTypes = propTypes;
AddDps.defaultProps = defaultProps;

const mapDispatchToProps = {
  getDps: dashboardActions.getDps,
};

export default connect(null,
  mapDispatchToProps,
)(injectIntl(CSSModules(AddDps,
  styles,
  { allowMultiple: true },
)));





// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/DpsModal/index.jsx